module.exports = __webpack_public_path__ + "static/media/landing-hero.e80391b9.svg";